import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { CoreConfigService } from "@core/services/config.service";
import { Property } from "app/modules/admin/properties/property.model";
import { LandingService } from "../landing.service";
import { environment } from "environments/environment";
import { User } from "../../../../auth/models/user";
import { PropertyService } from "../../../../../app/modules/admin/properties/property.service";
import { SwiperConfigInterface } from "ngx-swiper-wrapper";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class HomeComponent implements OnInit {
  temp: Array<object> = [];
  properties: any = [];
  propertiesRand: any;
  page = 1;
  pageSize = 8;
  sizeTable = 0;
  start: any;
  finish: any;
  userLoggeado: User;
  loading = true;
  loadingProperties = true;
  url = environment.URL_AWS;
  varPath = "https://inmoapp.test";
  config: any = {
    theme: 1,
  };
  query;
  constructor(
    private _coreConfigService: CoreConfigService,
    private _LandingService: LandingService,
    private _router: Router,
    private _propertyService: PropertyService
  ) {}

  async ngOnInit() {
    console.log("a ver", this._LandingService.sharingValue);

    console.log("INICIO MICROSITIO CONTROLADOR UNO");
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        customizer: false,
        enableLocalStorage: false,
      },
    };

    if (localStorage.getItem("currentUser")) {
      this.userLoggeado = JSON.parse(localStorage.getItem("currentUser"))?.user;
    }

    var host = window.location.host;
    const domain = host.split(".")[1];
    let data;
    if (domain == "in-mo" || domain == "inmoapp") {
      data = {
        domain: host.split(".")[0],
      };
    } else {
      data = {
        domain: environment.DOMAIN,
      };
    }
    console.log("INICIO MICROSITIO CONTROLADOR DOS", data);
    await this._LandingService.getConfig(data).then(
      (data: any) => {
        console.log("INICIO MICROSITIO CONTROLADOR DOS yes", data);
        this.config = data;
        if (this.config?.theme == 2) {
          this.pageSize = 9;
        }
        const style = document.createElement("style");
        style.innerHTML = `.page-item.active .page-link {
         background-color:${this.config?.primaryColor} !important;
     }`;
        this.loading = false;
        document.body.appendChild(style);
      },
      (error: any) => {
        console.log("INICIO MICROSITIO CONTROLADOR DOS error", error);
      }
    );
    console.log("INICIO MICROSITIO ngOnInit");
    const cadCon = this.userLoggeado ? this.userLoggeado.agentId : null;
    var host = window.location.host;
    data = null;
    const query = this._LandingService.sharingValue;
    this.query = query;
    if (localStorage.getItem("pageIndexCurrent")) {
      this.page = parseInt(localStorage.getItem("pageIndexCurrent"));
    }
    if (domain == "in-mo" || domain == "inmoapp") {
      data = {
        data: query,
        page: this.page,
        perPage: this.pageSize,
        domain: host.split(".")[0],
      };
    } else {
      data = {
        data: query,
        page: this.page,
        perPage: this.pageSize,
        domain: environment.DOMAIN,
      };
    }
    if (query == null) {
      this._LandingService.allProperties(cadCon, data).then(
        (resp: any) => {
          console.log("RESP propiedades", resp);
          this.properties = this.temp = resp.data;
          this.sizeTable = resp.total;
          if (this.config?.theme === 3) {
            if (this.properties.length > 5) {
              this.propertiesRand = this.getMultipleRandom(this.properties, 4);
            } else {
              this.propertiesRand = this.properties;
            }
          }
          this.loadingProperties = false;
        },
        (error: any) => {
          console.log("Error al obtener propiedades", error);
        }
      );
    } else {
      console.log("coño de su madre", data);
      this._LandingService.allPropertiesWithFilter(cadCon, data).then(
        (resp: any) => {
          console.log("RESP propiedades", resp);
          this.properties = this.temp = resp.data;
          this.sizeTable = resp.total;
          if (this.config?.theme === 3) {
            if (this.properties.length > 5) {
              this.propertiesRand = this.getMultipleRandom(this.properties, 4);
            } else {
              this.propertiesRand = this.properties;
            }
          }
          this.loadingProperties = false;
        },
        (error: any) => {
          console.log("Error al obtener propiedades", error);
        }
      );
    }
  }

  getMultipleRandom(arr, num) {
    const shuffled = [...arr].sort(() => 0.5 - Math.random());

    return shuffled.slice(0, num);
  }

  favorite(pro: Property) {
    this._propertyService.setFavoAgent(pro.id, this.userLoggeado.agentId).then(
      (resp: any) => {
        pro.landingFavorite = !pro.landingFavorite;
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  async onPageChange() {
    const query = this._LandingService.sharingValue;
    this.query = query;
    var host = window.location.host;
    const domain = host.split(".")[1];
    let data;
    if (domain == "in-mo" || domain == "inmoapp") {
      data = {
        data: query,
        page: this.page,
        perPage: this.pageSize,
        domain: host.split(".")[0],
      };
    } else {
      data = {
        data: query,
        page: this.page,
        perPage: this.pageSize,
        domain: environment.DOMAIN,
      };
    }

    this.loadingProperties = true;

    localStorage.setItem("pageIndexCurrent", this.page.toString());
    const cadCon = this.userLoggeado ? this.userLoggeado.agentId : null;
    // if(!this.page) this.page = 1;

    console.log("Entro a onPageChange", this.page);
    if (query == null) {
      this._LandingService
        .allProperties(cadCon, data)
        .then(
          (resp: any) => {
            console.log("AVER TRUE", resp);
            this.properties = this.temp = resp.data;
            this.sizeTable = resp.total;
            if (this.config?.theme === 3) {
              if (this.properties.length > 5) {
                this.propertiesRand = this.getMultipleRandom(this.properties, 4);
              } else {
                this.propertiesRand = this.properties;
              }
            }
          },
          (resp: any) => {
            console.log("AVER FALSE", resp);
          }
        )
        .finally(() => (this.loadingProperties = false));
    } else {
      console.log("coño de su madre", data);
      this._LandingService.allPropertiesWithFilter(cadCon, data).then(
        (resp: any) => {
          console.log("RESP propiedades", resp);
          this.properties = this.temp = resp.data;
          this.sizeTable = resp.total;
          if (this.config?.theme === 3) {
            if (this.properties.length > 5) {
              this.propertiesRand = this.getMultipleRandom(this.properties, 4);
            } else {
              this.propertiesRand = this.properties;
            }
          }
          this.loadingProperties = false;
        },
        (error: any) => {
          console.log("Error al obtener propiedades", error);
        }
      );
    }
  }

  getPageData() {
    this.start = (this.page - 1) * this.pageSize;
    this.finish = (this.page - 1) * this.pageSize + this.pageSize;

    this.properties = this.temp.slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }

  verDetalles(id: number): void {
    window.open("detalles/" + id, "_blank");
  }

  verProyecto(id: number, id_real_estate: number): void {
    window.open(`proyecto/${id}/inmobiliaria/${id_real_estate}`, "_blank");
  }

  borrarFiltro() {
    console.log("borrando filtros");
    this._LandingService.sharingValue = null;
    this.onPageChange();
  }

  sendWhatsApp(): void {
    window.open("https://wa.me/52" + this.config.phoneWhatsApp, "_blank");
  }

  changeCol(type: number) {
    let box = document.querySelectorAll(".colDynamic");

    // Remove all classes from element
    box.forEach((x) => (x.className = ""));

    switch (type) {
      case 1:
        this.pageSize = 4;
        this.onPageChange();
        // box.forEach(x => x.classList.add('col-6'));
        // box.forEach(x => x.classList.add('colDynamic'));
        break;
      case 2:
        this.pageSize = 9;
        this.onPageChange();
        // box.forEach(x => x.classList.add('col-4'));
        // box.forEach(x => x.classList.add('colDynamic'));
        break;
      case 3:
        this.pageSize = 8;
        this.onPageChange();
        // box.forEach(x => x.classList.add('col-3'));
        // box.forEach(x => x.classList.add('colDynamic'));
        break;
    }
  }

  public swiperFadeEffect: SwiperConfigInterface = {
    grabCursor: true,
    spaceBetween: 30,
    effect: "fade",
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
  };

  getCoinTypeName(coinType: number): string {
    switch (coinType) {
      case 1:
        return "MXN";
      case 2:
        return "USD";
      case 3:
        return "EUR";
      case 4:
        return "JPY";
      case 5:
        return "GBP";
      case 6:
        return "AUD";
      case 7:
        return "CAD";
      case 8:
        return "CHF";
      case 9:
        return "SGD";
      // Agrega más casos según tus necesidades
      default:
        return "MXN";
    }
  }

  getAmenidadAmueblado(amenidades: any) {
    const amueblado = amenidades.find((x) => x.amenity_id === 9);
    if (amueblado?.cantidad) {
      amueblado.cantidad = parseInt(amueblado.cantidad);
      return amueblado.cantidad === 1;
    } else {
      return false;
    }
  }
}
